<template>
  <div class="userinfo">
    <header-bar :name='!$route.query.works_id ? "上传作品" : "编辑单图信息"'></header-bar>
    <div class="content">
      <div class="formWrap">
        <van-uploader :after-read="afterRead" :max-size="10 * 1024 * 1024" accept=".jpg,.jpeg" :max-count="10" multiple/>
        <img src="../img/m/add_img.png" alt="" class="add_img">
        <div class="add_tip">
          在提交“故事图组”作品时，每组最少为3张图片，最多为10张，并通过文字说明故事中的内容，文字内容需与图片内容相符，否则不予通过审核，不能进行展示
        </div>
        <ul class="picList">
          <draggable v-model="picList"  chosen-class="chosen" handle=".cover" force-fallback="true" animation="500" @update="dataDragEnd">
            <transition-group>
              <li v-for="(v, i) in picList" :key="i">
                <div class="cover_con">
                  <img :src="'https://collection2021-cos.chineseplus.net/'+v.photo_cover" alt="" class="cover">
                  <div :class="['set_cover', cover_url == v.photo_cover ? 'active' : '']" @click="setCover(v, i)">
                    <img :src="cover_url == v.photo_cover ? require('../img/m/seting_cover2.png') : require('../img/m/seting_cover.png')" alt="">
                    <span>设为封面</span>
                  </div>
                  <img src="../img/m/delete_white.png" alt="" class="delete_white" @click="deleteFun(v, i)">
                </div>
                <textarea name="" id="" cols="30" rows="10" maxlength="150" class="picDes" placeholder="请输入150字内图片描述" v-model="v.photo_desc"></textarea>
              </li>
            </transition-group>
          </draggable>
        </ul>
      </div>
    </div>
    <div :class="['submit_btn', (picList.length >= 3 && picList.length <= 10) ? '' : 'disable']" @click="(picList.length >= 3 && picList.length <= 10) ? submitForm() : ''">
    <!-- <div :class="['submit_btn', (picList.length >= 3 && picList.length <= 10) ? '' : 'disable']" @click="submitForm()"> -->
      上传
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { Notify } from 'vant'
import draggable from 'vuedraggable'
import headerBar from './common/headerBar'

export default {
  components: {
    headerBar,
    draggable
  },
  data () {
    return {
      picList: [],
      cover_url: ''
    }
  },
  computed: {
    ...mapGetters(['getPicWorkInfo']),
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.checkInfo()
    if (this.$route.query.works_id) {
      this.getworkInfo()
    }
  },
  methods: {
    checkInfo () {
      if (this.getUserInfo.volunteer_info == 0) {
        this.$router.push({
          path: '/mpage/m_userinfo'
        })
      }
    },
    ...mapActions(['setPicWorkInfoAction']),
    getworkInfo () {
      this.$utils.get('/works/getInfo', {works_id: this.$route.query.works_id}).then(res => {
        if (res.code == 1000) {
          this.picList = res.data.photo_list
          this.cover_url = this.picList.find(v => v.is_cover == 1).photo_cover
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    },
    // 拖拽结束
    dataDragEnd (a) {
      this.picList[a.oldIndex].photo_sort = a.oldIndex
      this.picList[a.newIndex].photo_sort = a.newIndex
    },
    afterRead (file) {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      if (!Array.isArray(file)) {
        file = [file]
      }
      let newFile = file.map(v => {return v.file})
      let picParams = new FormData()
      newFile.forEach((e, index) => {
        picParams.append('images['+index+']', e)
      })

      this.$utils.postFile('/user/upload/create-images', picParams).then(res => {
        if (res.code == 1000) {
          if (!this.$route.query.works_id) {
            res.data.forEach(v => {
              let item = {
                photo_cover: v.url,
                photo_desc: ''
              }
              this.picList.push(item)
            })
          } else {
            let param = {
              works_id: this.$route.query.works_id,
              photo_cover: [],
              photo_desc: []
            }
            res.data.forEach(v => {
              param.photo_cover.push(v.url)
              param.photo_desc.push('')
            })
            this.$utils.postForm('/works/api/addPhoto', param).then(res => {
              if(res.code == 1000) {
                Notify({ type: 'success', duration: 1000, message: '添加成功!' })
                this.getworkInfo()
              } else {
                Notify({ type: 'warning', message: res.msg })
              }
            })
          }
        }
      })
    },
    // 删除
    deleteFun (v, i) {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      this.$dialog.confirm({
        message: '确定删除该图片吗？',
      })
      .then(() => {
        if (!this.$route.query.works_id) {
          this.picList.splice(i, 1)
        } else {
          this.$utils.postForm('/works/delPhoto', {photo_id: v.photo_id}).then(res => {
            if(res.code == 1000) {
              Notify({ type: 'success', message: '删除成功!' })
              this.getworkInfo()
            } else {
              Notify({ type: 'warning', message: res.msg })
            }
          })
        }
      })
      .catch(() => {
        
      })
    },
    // 设为封面
    setCover (v, i) {
      this.cover_url = v.photo_cover
      if (this.$route.query.works_id) {
        this.picList[i].is_cover = 1
      }
    },
    // 提交
    submitForm () {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      if (!this.cover_url) {
        Notify({ type: 'warning', duration: 1000, message: '请选择封面图' })
        return
      }
      if (!this.$route.query.works_id) {
        let photo_cover = []
        let photo_desc = []
        photo_cover = this.picList.map(v => {return v.photo_cover})
        photo_desc = this.picList.map(v => {return v.photo_desc})
  
        let param = {
          title: this.getPicWorkInfo.title,
          desc: this.getPicWorkInfo.desc,
          time: this.getPicWorkInfo.time,
          sid: this.getPicWorkInfo.sid,
          category_id: this.getPicWorkInfo.category_id,
          topic_id: this.getPicWorkInfo.topic_id,
          photo_cover: photo_cover,
          photo_desc: photo_desc,
          cover_url: this.cover_url
        }
        this.$utils.postForm('/works/api/submitPhoto', param).then(res => {
          if(res.code == 1000) {
            this.setPicWorkInfoAction({
              title: '',
              desc: '',
              time: new Date(),
              sid: undefined,
              category_id: undefined,
              topic_id: undefined
            })
            Notify({ type: 'success', duration: 1000, message: '作品提交成功!' })
            setTimeout(() => {
              this.$router.push({
                path: '/mpage/m_submit'
              })
            }, 1000)
          } else {
            Notify({ type: 'warning', message: res.msg })
          }
        })
      } else {
        let param = {
          works_id: this.$route.query.works_id,
          photo_list: this.picList
        }
        this.$utils.postForm('/works/api/updatePhoto', param).then(res => {
          if(res.code == 1000) {
            Notify({ type: 'success', duration: 1000, message: '修改成功!' })
            setTimeout(() => {
              this.$router.push({
                path: '/mpage/m_submit'
              })
            }, 1000)
          } else {
            Notify({ type: 'warning', message: res.msg })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.van-uploader {
  position: absolute;
  width: calc(100% - 1.15rem);
  .van-uploader__upload {
    width: calc(100% - 1.15rem);
    height: 7.57rem;
    margin: 0;
    opacity: 0;
  }
}
</style>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  overflow: hidden;
  .content {
    padding: .3rem .45rem 0 .45rem;
    box-sizing: border-box;
    .formWrap {
      background: #fff;
      min-height: calc(100vh - 5.85rem);
      padding: .7rem .7rem 0;
      // overflow: auto;
      padding-bottom: 1rem;
      .add_img {
        width: 100%;
      }
      .add_tip {
        font-size: .45rem;
        color: #999;
        line-height: 1.5;
        margin-top: .25rem;
      }
      .picList {
        li {
          margin-top: .6rem;
          .cover_con {
            width: 100%;
            height: 7.57rem;
            position: relative;
            .cover {
              width: 100%;
              height: 100%;
              display: block;
            }
            .set_cover {
              position: absolute;
              bottom: .33rem;
              left: .3rem;
              img {
                width: 1rem;
                vertical-align: middle;
              }
              span {
                color: #fff;
                font-size: .39rem;
                vertical-align: middle;
                margin-left: .05rem;
              }
              &.active {
                span {
                  color: #9576ef;
                }
              }
            }
            .delete_white {
              width: .68rem;
              position: absolute;
              bottom: .33rem;
              right: .3rem;
            }
          }
          .picDes {
            width: 100%;
            height: 3.7rem;
            margin-top: .28rem;
            line-height: 1.4;
            border: 0;
            resize: none;
            padding: 0;
            color: #999;
            font-size: .45rem;
            background: rgb(248, 248, 248);
          }
        }
      }
    }
  }
  .submit_btn {
    width: 100%;
    height: 2.41rem;
    background-color: #333;
    color: #fff;
    font-size: .8rem;
    text-align: center;
    line-height: 2.41rem;
    // position: fixed;
    // bottom: 0;
    &.disable {
      background-color: #b2b3b3;
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #999;
  }
}
</style>
